"use strict";

var _taggedTemplateLiteral = require("/home/circleci/project/story/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Block = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var sizes = {
  XL: {
    L: 256,
    M: 192,
    S: 96
  },
  L: {
    L: 128,
    M: 96,
    S: 48
  },
  M: {
    L: 96,
    M: 64,
    S: 32
  },
  S: {
    L: 40,
    M: 32,
    S: 20
  },
  XS: {
    L: 28,
    M: 28,
    S: 16
  }
};

var Block = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n  height: ", "px;\n\n  @media (min-width: 768px) {\n    height: ", "px;\n  }\n\n  @media (min-width: 1200px) {\n    height: ", "px;\n  }\n"])), function (props) {
  return sizes[props.paddingSize || 'S'].S;
}, function (props) {
  return sizes[props.paddingSize || 'S'].M;
}, function (props) {
  return sizes[props.paddingSize || 'S'].L;
});

exports.Block = Block;